import { Container } from '@chakra-ui/react';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { TemporaryEventListGrid } from '@/components/ui/features/events-list/EventListGrid/TemporaryEventListGrid';
import { TemporaryEventListTabs } from '@/components/ui/features/events-list/EventListTabs/TemporaryEventListTabs';
import { FeaturedEvent } from '@/components/ui/features/events-list/FeaturedEvent/FeaturedEvent';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResources } from '@/lib/datx-jsonapi-react';
import { queryFeaturedThinEvent } from '@/queries/thin-events';

export const TemporaryEventListContent: FC = () => {
  const { data: featuredEvents, error: feturedEventsError } = useResources(queryFeaturedThinEvent());

  const { accessFrom = AccessFrom.Core } = useQueryParams<{ accessFrom: AccessFrom }>({
    accessFrom: StringParam,
  });

  const featuredEvent = featuredEvents?.[0];

  if (!featuredEvents && !feturedEventsError) {
    return null;
  }

  const pt = featuredEvent ? { base: 28, lg: 20 } : { base: 6, md: 12, lg: 20 };

  return (
    <Layout accessFrom={accessFrom} navigationVariant={featuredEvent ? 'default' : 'inverted'}>
      {featuredEvent && <FeaturedEvent event={featuredEvent} />}
      <Container>
        <Section pt={pt} pb={{ base: 28, lg: 40 }} variant="dimmed" display="block">
          <TemporaryEventListTabs />
          <TemporaryEventListGrid />
        </Section>
      </Container>
    </Layout>
  );
};
